<template>
  <component :is="iconComponent" />
</template>

<script lang="ts" setup>
import type { IconName } from '@/types/generated/icons.gen'
import type { Component } from 'vue'
import { markRaw, ref, watchEffect } from 'vue'

const props = defineProps<{ name: IconName }>()

const iconComponent = ref<Component | null>(null)

// 使用 glob 导入所有 SVG 文件
const icons = import.meta.glob<{ default: Component }>(
  '/src/assets/icons/**/*.svg',
  { eager: true }
)

watchEffect(() => {
  const iconPath = `/src/assets/icons/${props.name}.svg`
  const module = icons[iconPath]
  if (module) {
    iconComponent.value = markRaw(module.default)
  } else {
    console.error(`Icon not found: ${props.name}`)
  }
})
</script>
